module.exports = __webpack_public_path__ + "static/media/21ECLAC46.a774b741.jpg";